import { reformatHeatmapData, reformatBeamRankData } from 'common/utils/helpers';
import { apiConfig } from 'config';

export function getRasterInfo(commissioningId) {
  const auth = window.__APP_AUTH;
  let url = apiConfig.commissionServiceGetRasterInfo(commissioningId);
  const headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json'
  };

  return fetch(url, { headers: headers, method: 'GET' }).then((response) => {
    if (response.status === 200) {
      return response.json().then((res) => {
        console.log(res);
        // return parseHeatmap(res.heatmap);
        console.log('getRasterInfo API res: ', res);
        let reformattedHeatmap = reformatHeatmapData(res.heatmap);
        let reformattedBeamrank = reformatBeamRankData(res.beamrank);
        return { heatmap: reformattedHeatmap, beamrank: reformattedBeamrank, activeBeam: res.activeBeam };
      });
    } else {
      return response.text().then((x) => {
        console.log('Error in raster heatmap API:', x);
        alert('Failed to retrieve raster heatmap:', x);
        throw new Error(x);
      });
    }
  });
}
